import { gql } from '@apollo/client';

export default gql`
    query loadEntityVersionsProcessQuery($orderBy: [JSON], $filterBy: [JSON], $excludeBy: [JSON], $startIndex: Int, $stopIndex: Int) {
        records: processDefinitionVersions(startIndex: $startIndex, stopIndex: $stopIndex, orderBy: $orderBy, filterBy: $filterBy, excludeBy: $excludeBy) {
            id
            name
            type
            primary
            iconName
            iconColor
            iconType
            description
            createdDate
            createdBy {
                id
                name
            }

            active
        }
    }
`;
